import React from 'react';
import formatTime, {getRFC3339} from 'mn-utils/formatTime';
import Tooltip from '../../../../dumb/Tooltip/A';
import {
  TRANSACTION_STATUS_DESCRIPTION_MAP,
  TRANSACTION_STATUS_TITLE_MAP,
} from './../constants';

const columnDateTime = (datetime, onlyDate = false) => {
  const title = getRFC3339(datetime);
  const date = formatTime(datetime, '{dd} {mmm}, {yyyy}');
  const time = formatTime(datetime, '{hh}:{MM}:{ss} {TT}');

  return (
    <Tooltip className="mA>1" title={title}>
      <span className="lh15">
        {date}
        {onlyDate ? null : (
          <span className="c717275 fw4 ml5">
            {time}
          </span>
        )}
      </span>
    </Tooltip>
  );
};


module.exports = (props) => {
  const {transaction} = props;
  const {remitter} = transaction || {};
  const {beneficiary} = transaction || {};

  return (
    <section>
      <div className="w mA dTB f16 mt10 mh30">
        <div className="dTBRG (dTBR)>1 (dTBC)>1>1
        (tr|cA4A7AC|f16|fw5|w35%)>1>1:first-child
        (tl|pl20|w60%|pr5%)>1>1:last-child">
          <div>
            <div>Transaction ID:</div>
            <div>
              <Tooltip title={transaction.id}>{transaction.id}</Tooltip>
            </div>
          </div>
          <div>
            <div>Transaction number:</div>
            <div>
              <Tooltip title={transaction.tx_number}>{transaction.tx_number}</Tooltip>
            </div>
          </div>
          <div>
            <div>Status:</div>
            <div>
              <Tooltip title={TRANSACTION_STATUS_DESCRIPTION_MAP[transaction.status]} disabledCopy>
                {TRANSACTION_STATUS_TITLE_MAP[transaction.status]}
              </Tooltip>
            </div>
          </div>
          <div>
            <div>Sub status:</div>
            <div>{transaction.sub_status || '-'}</div>
          </div>
          <div>
            <div>Status Description:</div>
            <div>{transaction.status_description || '-'}</div>
          </div>
          <div>
            <div>Created:</div>
            <div>
              <Tooltip title={getRFC3339(transaction.created_at)}>
                {columnDateTime(transaction.created_at)}
              </Tooltip>
            </div>
          </div>
          <div>
            <div>Updated:</div>
            <div>
              <Tooltip title={getRFC3339(transaction.updated_at)}>
                {columnDateTime(transaction.updated_at)}
              </Tooltip>
            </div>
          </div>
        </div>
      </div>

      <div className="f22 mt25">Remitter details</div>
      <div className="w mA dTB f16 mt10 mh30">
        <div className="dTBRG (dTBR)>1 (dTBC)>1>1
        (tr|cA4A7AC|f16|fw5|w35%)>1>1:first-child
        (tl|pl20|w60%|pr5%)>1>1:last-child">
          <div>
            <div>Nium account ID:</div>
            <div>
              <Tooltip title={remitter.nium_account_id || '-'}>
                {remitter.nium_account_id || '-'}
              </Tooltip>
            </div>
          </div>
          <div>
            <div>Fiat code:</div>
            <div>
              {remitter.fiat_code || '-'}
            </div>
          </div>
          <div>
            <div>Name:</div>
            <div>
              {remitter.name || '-'}
            </div>
          </div>
          <div>
            <div>Identification type:</div>
            <div>{remitter.identification_type || '-'}</div>
          </div>
          <div>
            <div>Identification number:</div>
            <div>{remitter.identification_number || '-'}</div>
          </div>
          <div>
            <div>Country code:</div>
            <div>{remitter.country_code || '-'}</div>
          </div>
          <div>
            <div>Address:</div>
            <div>
              {remitter.address || '-'}
            </div>
          </div>
          <div>
            <div>Source of income:</div>
            <div>
              {remitter.source_of_income || '-'}
            </div>
          </div>
          <div>
            <div>Contact number:</div>
            <div>
              {remitter.contact_number || '-'}
            </div>
          </div>
          <div>
            <div>Date of birth:</div>
            <div>
              {remitter.dob ? (
                <Tooltip title={remitter.dob}>
                  {columnDateTime(remitter.dob, true)}
                </Tooltip>
              ) : '-'}
            </div>
          </div>
          <div>
            <div>Postcode:</div>
            <div>
              {remitter.postcode || '-'}
            </div>
          </div>
          <div>
            <div>State:</div>
            <div>
              {remitter.state || '-'}
            </div>
          </div>
          <div>
            <div>Source of funds:</div>
            <div>
              {remitter.source_of_funds || '-'}
            </div>
          </div>
          <div>
            <div>Place of birth:</div>
            <div>
              {remitter.place_of_birth || '-'}
            </div>
          </div>
          <div>
            <div>Nationality:</div>
            <div>
              {remitter.nationality || '-'}
            </div>
          </div>
          <div>
            <div>Occupation:</div>
            <div>
              {remitter.occupation || '-'}
            </div>
          </div>
        </div>
      </div>

      <div className="f22 mt25">Beneficiary details</div>
      <div className="w mA dTB f16 mt10 mh30">
        <div className="dTBRG (dTBR)>1 (dTBC)>1>1
        (tr|cA4A7AC|f16|fw5|w35%)>1>1:first-child
        (tl|pl20|w60%|pr5%)>1>1:last-child">
          <div>
            <div>Merchant ID:</div>
            <div>
              <Tooltip title={beneficiary.merchant_id}>
                {beneficiary.merchant_id}
              </Tooltip>
            </div>
          </div>
          <div>
            <div>Name:</div>
            <div>
              {beneficiary.name || '-'}
            </div>
          </div>
          <div>
            <div>Email:</div>
            <div>
              <Tooltip title={beneficiary.email}>
                {beneficiary.email}
              </Tooltip>
            </div>
          </div>
          <div>
            <div>Account type:</div>
            <div>
              {beneficiary.account_type || '-'}
            </div>
          </div>
          <div>
            <div>Address:</div>
            <div>
              {beneficiary.address || '-'}
            </div>
          </div>
          <div>
            <div>City:</div>
            <div>
              {beneficiary.city || '-'}
            </div>
          </div>
          <div>
            <div>State:</div>
            <div>
              {beneficiary.state || '-'}
            </div>
          </div>
          <div>
            <div>Postcode:</div>
            <div>
              {beneficiary.postcode || '-'}
            </div>
          </div>
          <div>
            <div>Country code:</div>
            <div>
              {beneficiary.country_code || '-'}
            </div>
          </div>
          <div>
            <div>Contact number (without country code):</div>
            <div>
              {beneficiary.contact_number || '-'}
            </div>
          </div>
          <div>
            <div>Date of birth:</div>
            <div>
              {beneficiary.dob ? (
                <Tooltip title={beneficiary.dob}>
                  {columnDateTime(beneficiary.dob, true)}
                </Tooltip>
              ) : '-'}
            </div>
          </div>
          <div>
            <div>Wallet ID:</div>
            <div>
              {beneficiary.wallet_id ? (
                <Tooltip title={beneficiary.wallet_id}>
                  {beneficiary.wallet_id}
                </Tooltip>
              ) : '-'}
            </div>
          </div>
          <div>
            <div>Account number:</div>
            <div>
              {beneficiary.account_number || '-'}
            </div>
          </div>
          <div>
            <div>Bank account type:</div>
            <div>
              {beneficiary.bank_account_type || '-'}
            </div>
          </div>
          <div>
            <div>Bank name:</div>
            <div>
              {beneficiary.bank_name || '-'}
            </div>
          </div>
          <div>
            <div>Bank code:</div>
            <div>
              {beneficiary.bank_code || '-'}
            </div>
          </div>
          <div>
            <div>Identification type:</div>
            <div>
              {beneficiary.identification_type || '-'}
            </div>
          </div>
          <div>
            <div>Identification value:</div>
            <div>
              {beneficiary.identification_value || '-'}
            </div>
          </div>
          <div>
            <div>Card number:</div>
            <div>
              {beneficiary.card_number || '-'}
            </div>
          </div>
          <div>
            <div>Encrypted card number:</div>
            <div>
              {beneficiary.encrypted_card_number || '-'}
            </div>
          </div>
          <div>
            <div>Card expiry date:</div>
            <div>
              {beneficiary.card_expiry_date ? (
                <Tooltip title={beneficiary.card_expiry_date}>
                  {columnDateTime(beneficiary.card_expiry_date)}
                </Tooltip>
              ): '-'}
            </div>
          </div>
          <div>
            <div>Relationship:</div>
            <div>
              {beneficiary.relationship || '-'}
            </div>
          </div>
          <div>
            <div>Account identifier type:</div>
            <div>
              {beneficiary.account_identifier_type || '-'}
            </div>
          </div>
          <div>
            <div>Account identifier value:</div>
            <div>
              {beneficiary.account_identifier_value || '-'}
            </div>
          </div>
          <div>
            <div>Card token:</div>
            <div>
              {beneficiary.card_token || '-'}
            </div>
          </div>
          <div>
            <div>Contact country code:</div>
            <div>
              {beneficiary.contact_country_code || '-'}
            </div>
          </div>
          <div>
            <div>Name local language:</div>
            <div>
              {beneficiary.name_local_language || '-'}
            </div>
          </div>
          <div>
            <div>Routing code type 1:</div>
            <div>
              {beneficiary.routing_code_type_1 || '-'}
            </div>
          </div>
          <div>
            <div>Routing code value 1:</div>
            <div>
              {beneficiary.routing_code_value_1 || '-'}
            </div>
          </div>
          <div>
            <div>Routing code type 2:</div>
            <div>
              {beneficiary.routing_code_type_2 || '-'}
            </div>
          </div>
          <div>
            <div>Routing code value 2:</div>
            <div>
              {beneficiary.routing_code_value_2 || '-'}
            </div>
          </div>
          <div>
            <div>Routing code type 3:</div>
            <div>
              {beneficiary.routing_code_type_3 || '-'}
            </div>
          </div>
          <div>
            <div>Routing code value 3:</div>
            <div>
              {beneficiary.routing_code_value_3 || '-'}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
